export default {
  "contact": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contact us"])},
  "delete": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete"])},
  "hide": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hide"])},
  "reply": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reply"])},
  "trail": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["trail"])}
}